import React, { Component } from 'react'
//import { FormattedMessage } from 'react-intl'
import Button from '../../Button'
//import Close from '../../Icons/Close'
//import Input from '../../Input'
//import Loader from '../../Loader'
import Overlay from '../../Overlay'
import PersonComments from '../../../containers/PersonComments'
// import { addPersonComment} from '../store/reducers/comments'

export default class ProfileLotCard extends Component {

  constructor(props) {

    super(props)

    this.state = {
      modalActive: false,
      notifyModalActive: false,
      personInfo: {
        tmpPhotos: []
      },
      isChecked: false,
      isVisible: false,
      // status: 'completed'
    }
  }

  render() {

    const onSave = () => {
      this.setState({modalActive: false, notifyModalActive: false})
    }

    // const onSend = () => {
    //   addPersonComment(data._id, 'Всё ок');
    //   back();
    // }

    const { data, back } = this.props

    return (
      <div className='ProfileContainer'>
          <div className='ProfileContainer__wrapper'>
              <div className='ProfileContainer__header'>
                <img className='ProfileContainer__header-arrow' src="/assets/img/arrow.png" onClick={back} alt="" />
                <p className='ProfileContainer__header-left'>Карточка лота</p>
                <p className='ProfileContainer__header-right'>ожидает согласования</p>
              </div>
              <div className='ProfileContainer__main'>
                <a href={`previewlots/${data.alias}`} className='ProfileContainer__link' style={{textDecoration: "underline"}}>Предварительный просмотр</a>
                <div className="Become-member__agreement">
                    <label className='Become-member__agreement-container'>
                        <input type='checkbox' name='offerCheckbox' onChange={() => this.setState({isChecked: !this.state.isChecked})}/> 
                          <div className='Become-member__agreement-checkbox'>
                          <div className='Become-member__agreement-checkbox-arrow'></div>
                        </div>
                        <span className='Become-member__agreement-text' style={{color: "black"}}>
                          Нажимая на кнопку "Подтверждаю", я, в соответсии со статьёй 152.1 Гражданского Кодекса Российской Федерации, даю своё согласие на использование моих изображений
                        </span>
                    </label>
                    {(this.state.isVisible && !this.state.isChecked) && <span style={{ color: "red" }}><small>Необходимо согласиться с условиями</small></span>}
                </div>
              </div>
              <div className='Profile__input-group ProfileContainer__buttons'>
                  <Button theme="orange w100" onClick={() => this.setState({modalActive: true})} >
                        Комментировать
                  </Button>
                  <Button theme="orange w100" onClick={() => {this.state.isChecked ? this.setState({notifyModalActive: true}) : this.setState({isVisible: true})}} >
                  {/* <Button theme="orange w100" onClick={() => {this.state.isChecked ? back() : this.setState({isVisible: true})}} > */}
                        Подтверждаю
                  </Button>
              </div>
          </div>
          <Overlay isActive={this.state.modalActive} klassModifier='mfc-modal_4'>
            <PersonComments lotId={data._id} personInfo={this.state.personInfo} status={'requested'}  onSave={onSave}/>
          </Overlay>

          <Overlay isActive={this.state.notifyModalActive} klassModifier={"welcome-persone mfc-modal_4"}>
            <PersonComments lotId={data._id} personInfo={this.state.personInfo} status={'completed'} onSave={onSave}/>
          </Overlay>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PersonProfile/ProfileContainers/ProfileLotCard.jsx